import React, {useEffect, useState} from 'react';
import USER_DISPLAY_STRINGS from '../../resources/user_display_strings';
import { useRouteLoadDurationPublisher } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';
import RecentAppsPane from '../RecentApps';
import { NavigableApplicationsObject } from '../RecentApps/types';
import { get as _get } from "lodash";
import { getArgoConfig } from '@awsscm/argo-core/argo/window';
import { getConfigValue } from '../../config/appConfig';

interface LandingPageProps {
  recentlyUsedLinks: NavigableApplicationsObject[];
  onTogglePinApp?: (app: NavigableApplicationsObject) => void;
  recentAppsLoading: boolean;
  recentAppsError: Error | null;
}

export default function LandingPage({ recentlyUsedLinks, onTogglePinApp, recentAppsLoading, recentAppsError }: LandingPageProps) {
  const publishRouteLoadDuration = useRouteLoadDurationPublisher();

  publishRouteLoadDuration();
  if (getConfigValue('enableRecentApps')) {
    return (
    <div className="asui-grid awsscm-ui">
      <div className="awsui-util-action-stripe-large">
        <div className="awsui-util-action-stripe-title">
          <h1>{USER_DISPLAY_STRINGS.mainTitle}</h1>
          <h3>{USER_DISPLAY_STRINGS.recentAppsHeader}</h3>
          <RecentAppsPane 
            recentlyUsedLinks={recentlyUsedLinks}
            onTogglePinApp={onTogglePinApp}
            loading={recentAppsLoading}
            error={recentAppsError}
          />
        </div>
      </div>
    </div>
  );
  }
    return (
      <div className="asui-grid awsscm-ui">
      <div className="awsui-util-action-stripe-large">
        <div className="awsui-util-action-stripe-title">
          <h1>{USER_DISPLAY_STRINGS.mainTitle}</h1>
          <p>{USER_DISPLAY_STRINGS.helpText}</p>
        </div>
      </div>
    </div>
    );
}
